import React from 'react';

import Typography from '@components/typography';
import Option from '@components/option';

import { useAppDispatch, useAppSelector } from '@hooks/statehooks';
import { removeOptionParam } from '@store/reducers/vehiclesearchparams';
import { removeOption } from '@store/reducers/selectedoptions';

import { useSelectedOptions } from '@hooks/useselectedoptions';
import { usePricing } from '@hooks/usepricing';

import '@styles/configure/selectedoptions.scss';
import { VehicleOptionItem } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicleoptionitem';

const SelectedOptions: React.FC = () => {
  const { selectedOptions } = useSelectedOptions();

  const searchParams = useAppSelector((state) => state.vehicleSearchParams);
  const { pricingType } = useAppSelector((state) => state.vehicleInformation);

  const dispatch = useAppDispatch();

  const { updatePricingWithOptions } = usePricing();

  const handleDependantOptions = (id: number, updateOptions: number[]) => {
    const option = selectedOptions.find((f) => f.id === id);

    if (option?.optionRules && option.optionRules.length > 0) {
      option.optionRules.forEach((e: VehicleOptionItem) => {
        //Check the dependant is not required to be selected on another parent

        if (
          selectedOptions.find(
            (f) =>
              f.id !== id &&
              f.optionRules.find((d) => d.id === e.id && d.checked)
          )
        ) {
          return;
        }

        dispatch(removeOption(e.id));
        dispatch(removeOptionParam(e.id));
        updateOptions = updateOptions.filter((f) => f !== e.id)!;
      });
    }

    return updateOptions;
  };

  const clickRemoveHandler = (id: number) => {
    dispatch(removeOption(id));
    dispatch(removeOptionParam(id));

    let updateOptions = searchParams.optionsSelected?.filter(
      (option) => option !== id
    )!;

    updateOptions = handleDependantOptions(id, updateOptions);

    updatePricingWithOptions(updateOptions, updateOptions[0], pricingType);
  };

  const renderSelectedOptions = () =>
    selectedOptions.map((selection, index) => (
      <Option
        key={index}
        clickRemoveHandler={() => clickRemoveHandler(selection.id)}
        {...selection}
      />
    ));

  return (
    <>
      <div
        className="selected-options"
        data-testid="selected-options"
        data-cy="selected-options"
      >
        <Typography
          variant="h2"
          size="rg"
          className="selected-options__header"
          weight="bold"
        >
          Your Selected Options
        </Typography>
        {selectedOptions.length > 0 && (
          <div className="selected-options__content">
            {renderSelectedOptions()}
          </div>
        )}
      </div>
    </>
  );
};

export default SelectedOptions;
